const CONTENT_FILTERED = "zz_AgentApiErrorCode_ContentFiltered";

export const isContentFiltered = (error: unknown): boolean =>
  (error as { data?: { errorCode?: unknown } } | null)?.data?.errorCode ===
  CONTENT_FILTERED;

export const contentFilteredNote = (
  documentNames: readonly string[],
): string => {
  const read =
    documentNames.length > 0
      ? ` mens assistenten leste ${documentNames.map((name) => `«${name}»`).join(", ")}`
      : "";
  return (
    `KI-tjenestens innholdsfilter stoppet svaret${read}. ` +
    "Filteret vil stoppe det samme spørsmålet igjen. Du kan stille et annet spørsmål i samtalen."
  );
};
